module.exports = __webpack_public_path__ + "img/1.f0904ad0.jpg";